const FuelCodeType = {
  DriverSpecific: "driver-specific",
  VehicleSpecific: "vehicle-specific",
  DriverVehicleSpecific: "driver-vehicle-specific",
  AnyDriverAnyVehicle: "any",
};

export default FuelCodeType;
